import { useState } from "react";

/** A value created once on mount and kept for the component's lifetime. */
export const useConstant = <TValue>(create: () => TValue): TValue => {
    // oxlint-disable-next-line react/hook-use-state -- Created once, never updated.
    const [value] = useState(create);
    return value;
};
